import apiClient from '../../../shared/services/apiHelper';
import {
  setAuthToken,
  setUserData,
  clearAuthData
} from '../../../shared/utils/authStorage';
import { validateResponse } from '../../../shared/utils/responseHelper';

export const authService = {
  /**
   * Send OTP to phone number
   * @param {string} phoneNumber - User's phone number
   * @returns {Promise} - OTP send response
   */
  sendOTP: async (phoneNumber, dialCode) => {
    try {
      const response = await apiClient.post('/auth/otp', {
        mobile: phoneNumber,
        dial_code: dialCode
      });
      return validateResponse(response, 'Failed to send OTP');
    } catch (error) {
      console.error('Error sending OTP:', error);
      throw error;
    }
  },

  /**
   * Verify OTP and authenticate user
   * @param {string} phoneNumber - User's phone number
   * @param {string} otp - OTP code
   * @returns {Promise} - Authentication response with token
   */
  verifyOTP: async (phoneNumber, otp) => {
    try {
      const response = await apiClient.post(
        '/auth/user-auth',
        {
          phone_number: phoneNumber,
          otp: otp
        },
        null, // queryParameters
      );
      const data = validateResponse(response, 'Failed to verify OTP');
      console.log("Parsed data:", data); 
      return data;
    } catch (error) {
      console.error('Error verifying OTP:', error);
      throw error;
    }
  },

  /**
   * Logout user
   * @returns {Promise} - Logout response
   */
  logout: async () => {
    try {
      // If you have a logout endpoint, uncomment and use it
      // const response = await apiClient.post('/auth/logout');
      clearAuthData();

      return { success: true, message: 'Logged out successfully' };
    } catch (error) {
      console.error('Error during logout:', error);
      clearAuthData();
      throw error;
    }
  }
};


// sample user auth api response




// {
//   "success": true,
//   "status_override": 0,
//   "data": {
//       "access_token": "3611ebb36146ca12f5a26e5e98168937",
//       "user_id": 132,
//       "device_id": null,
//       "first_name": "",
//       "last_name": "",
//       "display_name": null,
//       "phone_number": "002002002",
//       "email": "jfhd6pmqim@ruutukf.com",
//       "address_id": null,
//       "gender": "",
//       "dob": "",
//       "latitude": "",
//       "longitude": "",
//       "display_picture": "",
//       "job_expertise": [],
//       "access_level": "Customer",
//       "user_desc": "",
//       "user_designation": "Customer",
//       "user_type": 0,
//       "organization_unit": {
//           "org_id": 6,
//           "org_name": "NITHIN AND CO",
//           "tag_line": "",
//           "org_logo": "https://tykven-v3-staging.s3.ap-south-1.amazonaws.com/orgs/006d1236aee3f92b8322299796ba1989/medias/jn98Z5Pg7SXosi0wf9UCwv7jVwt90wFB.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAVFIWJDSJOXUYILME%2F20260413%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20260413T090201Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=d0e2c41c9b996c075ea721448d48c4a8342f83a8a73e9e0a05757b2ff0dd6c6e",
//           "default_language_id": 1,
//           "currency_id": 3,
//           "config": {
//               "date_short": "dd/MMM/yy",
//               "date_long": "dd/MMM/yy h:mm a",
//               "date_short_numeric": "dd/MM/yy",
//               "date_long_numeric": "dd/MM/yy h:mm a",
//               "tax_label": "",
//               "tax_percentage": 0,
//               "shift_start_time": "",
//               "shift_end_time": "",
//               "shift_hours": 0,
//               "monthly_min_work_hrs": 0,
//               "technician_invoice_access": false,
//               "technician_work_order_access": false,
//               "disabled_features": {
//                   "feature_1": "disabled",
//                   "feature_2": "disabled",
//                   "feature_3": "enabled"
//               },
//               "module_config": {
//                   "organisation_details": {
//                       "org_domain_url": "",
//                       "org_email": "dummy@mail.com",
//                       "org_phone": "32343232"
//                   },
//                   "language": "English",
//                   "industry_type": "HVAC",
//                   "currency": "INR",
//                   "currency_symbol": "₹",
//                   "financial": "true",
//                   "is_sla": "true",
//                   "users_limit": "",
//                   "labour_cost_per_hour": "100",
//                   "config_setup": {
//                       "equipment_verify": "0",
//                       "allow_live_tracking": "0",
//                       "spare_managemnet": "0",
//                       "add_equipment": "0",
//                       "pre_inspection_report": "0",
//                       "estimation_report": "0",
//                       "leave_managemnet": "0",
//                       "holiday_managemnet": "0",
//                       "leads_managemnet": "0",
//                       "allow_se_add_wo": "0",
//                       "enable_checklist": "0",
//                       "allow_se_make_model": "0",
//                       "estimate_laour_cost_update": "0",
//                       "push_notification_allow": "0",
//                       "estimate_create": "0",
//                       "inspection_create": "0",
//                       "live_tracking": "0",
//                       "hours_available_monthly": "0"
//                   },
//                   "is_reports": "true",
//                   "reports": {
//                       "wo_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "wo_status_report": "0",
//                               "wo_aging_report": "0"
//                           }
//                       },
//                       "financial_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "cost_per_work_order": "0",
//                               "labour_cost": "0",
//                               "parts_cost": "0",
//                               "revenue_by_technician": "0"
//                           }
//                       },
//                       "technician_performance_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "technician_productivity_report": "0",
//                               "technician_wo_time": "0",
//                               "technician_wo_travel_time": "0"
//                           }
//                       },
//                       "service_request_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "response_time_analysis": "0"
//                           }
//                       },
//                       "schedule_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "resource_allocation": "0",
//                               "job_schedule": "0",
//                               "resource": "0",
//                               "delay": "0",
//                               "technician_efficiency": "0",
//                               "work_order_analysis": "0"
//                           }
//                       },
//                       "client_specific_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "client_summary_report": "0",
//                               "client_transaction_report": "0",
//                               "client_feedback_report": "0"
//                           }
//                       },
//                       "operational_efficiency_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "mean_time_to_repair": "0",
//                               "resource_utilisation_report": "0",
//                               "mttr_over_time": "0"
//                           }
//                       },
//                       "asset_and_equipment_reports": {
//                           "isEnabled": "true",
//                           "config": {
//                               "asset_performance": "0",
//                               "asset_performance_trend": "0",
//                               "warranty_summary_report": "0"
//                           }
//                       }
//                   },
//                   "push_notification": {
//                       "enabled": "true",
//                       "role_settings": {
//                           "service_manager": {
//                               "enabled": "true",
//                               "events": {
//                                   "task_assigned": "true",
//                                   "task_completed": "true",
//                                   "task_cancelled": "true",
//                                   "task_accepted": "true",
//                                   "task_unassigned": "true",
//                                   "estimate_accepted": "true",
//                                   "estimate_rejected": "true",
//                                   "estimation_created": "true",
//                                   "work_report_confirmed": "true",
//                                   "work_report_generated": "true",
//                                   "pra_assigned": "true",
//                                   "pra_completed": "true",
//                                   "pra_rejected": "true",
//                                   "pra_accepted": "true",
//                                   "spare_parts_requested": "true",
//                                   "spare_parts_accepted": "true",
//                                   "spare_parts_cancelled": "true",
//                                   "amc_expiry_reminder": "true",
//                                   "amc_requested": "true",
//                                   "service_request_created": "true",
//                                   "client_estimation_approved": "true",
//                                   "lead_added": "true"
//                               }
//                           },
//                           "service_engineer": {
//                               "enabled": "true",
//                               "events": {
//                                   "task_assigned": "true",
//                                   "task_completed": "true",
//                                   "task_cancelled": "true",
//                                   "task_accepted": "true",
//                                   "task_unassigned": "true",
//                                   "estimate_accepted": "true",
//                                   "estimate_rejected": "true",
//                                   "estimation_created": "true",
//                                   "work_report_confirmed": "true",
//                                   "work_report_generated": "true",
//                                   "pra_assigned": "true",
//                                   "pra_completed": "true",
//                                   "pra_rejected": "true",
//                                   "pra_accepted": "true",
//                                   "spare_parts_requested": "true",
//                                   "spare_parts_accepted": "true",
//                                   "spare_parts_cancelled": "true",
//                                   "amc_expiry_reminder": "true",
//                                   "amc_requested": "true",
//                                   "service_request_created": "true",
//                                   "client_estimation_approved": "true",
//                                   "lead_added": "true"
//                               }
//                           }
//                       }
//                   }
//               },
//               "max_estimate_amount": 0,
//               "enable_bulk_task_assign": false,
//               "require_mobile_otp": false,
//               "locale": "en-IN",
//               "timezone": "Asia/Kolkata"
//           },
//           "storage": {
//               "root": "prod/orgs/1679091c5a880faf6fb5e6087eb1b2dc",
//               "medias": "prod/orgs/1679091c5a880faf6fb5e6087eb1b2dc/medias",
//               "invoices": "prod/orgs/1679091c5a880faf6fb5e6087eb1b2dc/invoices"
//           },
//           "address": {
//               "address1": "South Railway",
//               "address2": "",
//               "state": "",
//               "city": "",
//               "country_id": 106,
//               "postcode": "",
//               "landmark": "",
//               "latitude": "",
//               "longitude": "",
//               "address_type": 1
//           }
//       },
//       "customer": {
//           "id": 134,
//           "company_name": "Clint EastWood",
//           "phone": "002002002",
//           "contact_phone": null
//       },
//       "user_supervisor_id": [],
//       "timezone_id": -1,
//       "session_id": 260,
//       "session_started_at": 1776070921752,
//       "device_type": 7,
//       "is_session_active": 1,
//       "address": {
//           "address1": null,
//           "address2": null,
//           "state": null,
//           "city": null,
//           "country_id": 0,
//           "postcode": null,
//           "landmark": null,
//           "latitude": null,
//           "longitude": null,
//           "address_type": 0
//       },
//       "configurations": {
//           "app_access_level": 0,
//           "last_updated": "",
//           "skills": []
//       }
//   }
// }